import { Injectable, inject } from '@angular/core';
import { CategoryModel } from '../models/category.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from './http.service';

@Injectable()
export class CategoriesService {
    private httpService = inject(HttpService);

    getCategories$(): Observable<CategoryModel[]> {
        return this.httpService.getCategories().pipe(
            map((categories) => {
                const featuredCategories = categories.filter((category) => category.featured === true);
                return featuredCategories;
            }),
        );
    }
}
